// @flow
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2020 Adobe
*  All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains the property of Adobe and its suppliers, if any. The 
* intellectual and technical concepts contained herein are proprietary to Adobe and its suppliers and are protected by all 
* applicable intellectual property laws, including trade secret and copyright laws. Dissemination of this information or 
* reproduction of this material is strictly forbidden unless prior written permission is obtained from Adobe.
**************************************************************************/ 

import {setCookie, getCookie} from './cookie';

const WEB_STORAGE_TYPES = ['sessionStorage', 'localStorage'];

export default class WebStorage {
    type: string;

    constructor(type: string) {
        this.type = WEB_STORAGE_TYPES.includes(type) ? type : WEB_STORAGE_TYPES[0];
    }

    set(key: string, value: string, domain: string, secure: boolean) {
        try {
            window[this.type].setItem(key, value);
        }
        catch (e) {
            setCookie(key, encodeURIComponent(value), null, domain, secure);
        }
    }

    remove(key: string, domain: string, secure: boolean) {
        try {
            window[this.type].removeItem(key);
        }
        catch (e) {
            setCookie(key, '', -1, domain, secure);
        }
    }

    get(key: string) {
        try {
            return window[this.type].getItem(key);
        }
        catch (e) {
            const cookie = getCookie(key);
            return cookie === null ? null : decodeURIComponent(cookie);
        }
    }
}
